import { UseMutationOptions, useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CreateUserParams, MbapiAdminService } from 'src/Services/API';

import { QueryKeys } from '../types';

export const useCreateUser = (
  extraOptions?: UseMutationOptions<void, AxiosError, CreateUserParams>
) => {
  const queryClient = useQueryClient();

  return useMutation(
    async body => {
      await MbapiAdminService.mbapiAdminControllerCreateUser({ body });
    },
    {
      ...extraOptions,
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries([QueryKeys.getAllRoutes]);
        extraOptions?.onSuccess?.(data, variables, context);
      },
    }
  );
};
